import React from "react";

const ShowPasswordIcon = () => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5.15556C3.49333 -0.385185 10.9733 -0.385185 13.4667 5.15556"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.2333 7.92558C6.96044 7.92558 6.69025 7.87183 6.43816 7.76741C6.18608 7.663 5.95702 7.50995 5.76408 7.31701C5.57114 7.12407 5.4181 6.89502 5.31368 6.64293C5.20926 6.39084 5.15552 6.12066 5.15552 5.8478C5.15552 5.57494 5.20926 5.30475 5.31368 5.05267C5.4181 4.80058 5.57114 4.57153 5.76408 4.37859C5.95702 4.18565 6.18608 4.0326 6.43816 3.92818C6.69025 3.82376 6.96044 3.77002 7.2333 3.77002C7.78436 3.77002 8.31285 3.98893 8.70251 4.37859C9.09217 4.76825 9.31107 5.29674 9.31107 5.8478C9.31107 6.39886 9.09217 6.92735 8.70251 7.31701C8.31285 7.70667 7.78436 7.92558 7.2333 7.92558Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShowPasswordIcon;
